// DualColorCircle.js
import PropTypes from 'prop-types';
import colors from '../../utils/colors';

const DualColorCircle = ({ color1, color2, size = 100, onClick, isChecked }) => {
  return (
    <div
      className="dual-color-circle"
      style={{
        width: size,
        height: size,
        background: `linear-gradient(135deg, ${color1} 50%, ${color2} 50%)`,
        borderRadius: '50%',
        position: 'relative',
        cursor: 'pointer',
        border: isChecked ? `2.5px solid ${localStorage.getItem("layoutMode") === "dark" ? colors.white : colors.brown}` : 'none',
      }}
      onClick={onClick}
      role="button"
      aria-label={`Select ${isChecked ? 'selected ' : ''}theme color`}
      aria-pressed={isChecked}
    >
      {isChecked && (
        <div
          className="check-icon"
          style={{
            position: 'absolute',
            bottom: '10%',
            right: '10%',
            width: size * 0.2,
            height: size * 0.2,
            backgroundColor: 'navy',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: 'white',
            fontSize: size * 0.1,
          }}
        >
          &#10003;
        </div>
      )}
    </div>
  );
};


DualColorCircle.propTypes = {
  color1: PropTypes.string.isRequired,
  color2: PropTypes.string.isRequired,
  size: PropTypes.number,
  onClick: PropTypes.func,
};

export default DualColorCircle;
